import { Link } from "react-router-dom";

const faqs = [
  {
    q: "动漫网的动漫列表多久更新一次？",
    a: "动漫网会持续同步新番索引与连载作品信息，每季新番上线前后都会及时更新，确保用户能看到最新的全部动漫列表与状态。",
  },
  {
    q: "如何在动漫网快速找到想看的动漫？",
    a: "你可以通过顶部的检索入口进入全部动漫页面，再根据国漫、日漫、热血、治愈等漫画分类大全进行筛选，快速锁定目标作品。",
  },
  {
    q: "动漫网支持国漫和日漫检索吗？",
    a: "支持。动漫网专门设有国漫专区与日漫检索入口，配合动画库，让你在找漫画、追更新时一站搞定，不用再翻来翻去。",
  },
  {
    q: "浏览动漫网需要注册账号吗？",
    a: "不需要。动漫网作为公开的资源聚合检索入口，用户可以免费浏览全部动漫列表、新番索引与各类资讯，无需注册即可使用。",
  },
];

export default function Faq() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto px-4 md:px-6">
        <div className="mx-auto max-w-3xl text-center">
          <span className="font-heading text-sm text-primary-600">常见问题</span>
          <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-4xl">使用动漫网，你可能想问</h2>
          <p className="mt-3 text-sm text-foreground-600 md:text-base">
            关于动漫网全部动漫列表、新番索引与漫画分类大全的常见问题解答。
          </p>
        </div>

        <div className="mx-auto mt-8 grid max-w-3xl grid-cols-1 gap-4">
          {faqs.map((item) => (
            <details
              key={item.q}
              className="group rounded-lg border border-background-200/70 bg-background-50 p-5"
            >
              <summary className="flex cursor-pointer items-center justify-between gap-3 text-sm font-medium text-foreground-950 md:text-base">
                {item.q}
                <i className="ri-add-line text-foreground-500 transition-transform group-open:rotate-45"></i>
              </summary>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{item.a}</p>
            </details>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/about"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            了解更多关于动漫网
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}